<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>3、帮助通知</span>
      <!-- <el-button style="float: right; padding: 3px 0" type="text"
              >操作按钮</el-button
            > -->
    </div>
    <div class="item">
      <a
        href="https://www.xjzcsq.com/xjzcsq/upload/files/2023/8/24ef855fc5961a6.pdf"
        target="_blank"
        ><i class="el-icon-question"></i>专家库使用操作指南</a
      >
    </div>
  </el-card>
</template>

<script>
export default {};
</script>

<style>
</style>